import * as React from 'react';

export const Accordion = () => {
  return (
    <div>
      <p>Hello, Accordion.</p>
    </div>
  );
};
